<template>
    <div class="p-3">
        <el-card header="Pedidos atendidos">
            <PaginatedTable :loading="loading" :page="data.current_page" :show-rows="10" :pages="data.last_page" :data="data.data" :height="450" :cols="[
                {label: 'Cod', prop: 'id'},
                {label: 'Estado', prop: 'status'},
                {label: 'Contacto', prop: 'phone'},
            ]" @change="changePage">
                <el-table-column label="Cliente">
                    <template #default="data">
                        {{ data.row.user?.name}}
                    </template>
                </el-table-column>
                <el-table-column label="Entregador">
                    <template #default="data">
                        {{ data.row.delivery?.name ?? '----'}}
                    </template>
                </el-table-column>
                <el-table-column label="Data e hora">
                    <template #default="data">
                        {{ new Date(data.row.created_at).toLocaleString() }}
                    </template>
                </el-table-column>
                <el-table-column label="Ver mais">
                    <template #default="data">
                        <el-button type="primary" tag="router-link" :to="'/requests/' + data.row.id" icon="View" title="Ver mais"></el-button>
                    </template>
                </el-table-column>
            </PaginatedTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessageBox } from 'element-plus';
    import { Order } from '@/services/types/order';
    import { Paginated } from '@/services/types/paginated';
    import { defaultPaginated } from '@/utilities/helpers';
    import PaginatedTable from '@/components/PaginatedTable.vue';

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Order>>(defaultPaginated)

    const getOrders = async (p = 1) => {
        loading.value = true
        const res = await Api.get(`admin/orders?old=on&page=${p}`)
        if (res.status == 200) {
            data.value = res.data.orders
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }

    onBeforeMount(() => {
        getOrders(1)
    })

    const changePage = (p = 1) => {
        getOrders(p)
    } 
</script>
